import {Button, Modal} from 'react-bootstrap';
import React from 'react';
import ArticleSelector from './ArticleSelector';

class ArticleSelectModal extends React.Component {
  render() {
    return (
      <div>
        <Modal
          bsSize="large"
          show={this.props.show}
          backdrop={true}
          onHide={this.props.onHide}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title>Velg et element</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <ArticleSelector
              onSelect={this.props.onSelect}
              contentType={this.props.contentType}
              searcher={this.props.searcher}
              searchOnOpen={this.props.searchOnOpen}
            />
          </Modal.Body>

          <Modal.Footer>
            <Button
              bsStyle="primary"
              onClick={this.props.onHide}
            >
                Avbryt
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

ArticleSelectModal.defaultProps = {
  show: true
};

export default ArticleSelectModal;
